
















































import { defineComponent, computed } from '@vue/composition-api';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import { CONSTANT_URL } from '@/renderer/scripts/http';
import { encodeText } from '@/renderer/scripts/utils/tools';

export default defineComponent({
  props: {
    show: Boolean,
    bindInfo: {
      type: Object,
      default: () => {
        return {
          code: '',
          phoneNumber: '',
          sms: '',
        };
      },
    },
  },
  setup(props, context) {
    const vm = context.root;
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });

    const methods = {
      clickButton(type: string) {
        if (type === 'buy') {
          dispatchRouter(CONSTANT_URL.buyEnterpriseUrl);
          reporter.report('login_not_joined', { click_type: 'no' });
        } else if (type === 'register') {
          const bind = encodeText(JSON.stringify(props.bindInfo));
          // 登录页直接打开，分享页需新开一个页面
          if (vm.$route.name === 'login') {
            dispatchRouter({ name: 'register', query: { from: 'login_tips_pop_up', bind } });
          } else {
            const routeName = vm.$route.name ?? 'share';
            const newpage = vm.$router.resolve({
              path: '/login/register',
              query: { from: routeName, bind },
            });
            window.open(newpage?.href, '_blank');
          }
        } else {
          reporter.report('login_not_joined', { click_type: 'yes' });
          dispatchRouter(CONSTANT_URL.consoleManagementUrl);
        }
      },
    };

    return {
      innerShow,
      ...methods,
    };
  },
});
